const ch = {
  '赞助和游戏责任': '赞助和游戏责任',
  '产品': '产品',
  '游戏': '游戏',
  "踏入刺激，今天就在我们的在线游戏中试试你的运气吧！刺激和奖励等着你!": '踏入刺激，今天就在我们的在线游戏中试试你的运气吧！刺激和奖励等着你!',
  '排名': '排名',
  "更多的": "更多的",
  "拱廊": "拱廊",
  "撞车游戏": "撞车游戏",
  "钓鱼游戏": "钓鱼游戏",
  "直播": "直播",
  "登录": "登录",
  "注册": '注册',
  "选择语言": '选择语言',
  "介绍人": "介绍人",
  "账号": "账号",
  "密码": "密码",
  "确认密码": "确认密码",
  "真实姓名": "真实姓名",
  "手机号码": "手机号码",
  "取款密码": "取款密码",
  "验证码": "验证码",
  "请输入密码": "请输入密码",
  "请输入验证码": "请输入验证码",
  "请输入账号": "请输入账号",
  "请重新获取验证码": "请重新获取验证码",
  "正在登录中": "正在登录中",
  "网络异常,请稍后再试": "网络异常,请稍后再试",
  "账号名": "账号名",
  "余额": "余额",
  "会员中心": "会员中心",
  "网上存款": "网上存款",
  "网上提款": "网上提款",
  "退出": "退出",
  "请再次输入密码": "请再次输入密码",
  "请输入姓名": "请输入姓名",
  "请输入手机号": "请输入手机号",
  "请输入取款密码": "请输入取款密码",
  "正在注册中": "正在注册中",
  "确定": "确定",
  "注册成功": "注册成功",
  "热门优惠": "热门优惠",
  "首页": "首页",
  "查看活动": "查看活动",
  "正在获取活动列表": "正在获取活动列表",
  "暂无活动": "暂无活动",
  "活动详情": "活动详情",
  "视讯直播": "视讯直播",
  "直播类型": "直播类型",
  "热门": "热门",
  "推荐": "推荐",
  "最新": "最新",
  "全部": "全部",
  "获取类型中": "获取类型中",
  "获取具体信息中": "获取具体信息中",
  "开始": "开始",
  "正在获取资源": "正在获取资源",
  "正在努力加载中": "正在努力加载中",
  "电子": "电子",
  "大厅": "大厅",
  "游戏类型": "游戏类型",
  "游戏标签": "游戏标签",
  "错误的类型": "错误的类型",
  "返回首页": "返回首页",
  "正在获取游戏列表": "正在获取游戏列表",
  "暂无游戏": "暂无游戏",
  "当前未登录,请先登录": "当前未登录,请先登录",
  "联系我们": "联系我们",
  "导航": "导航",
  "配置文件信息": "配置文件信息",
  "常用功能": "常用功能",
  "充值": "充值",
  "提现": "提现",
  "功能列表": "功能列表",
  "交易": "交易",
  "设置": "设置",
  "修改登入密码": "修改登入密码",
  "修改提现密码": "修改提现密码",
  "银行卡": "银行卡",
  "若您先前透由手机号或社交平台登录站点，请您直接联系客服协助设置": "若您先前透由手机号或社交平台登录站点，请您直接联系客服协助设置",
  "旧密码": "旧密码",
  "请输入旧密码": "请输入旧密码",
  "设定新密码": "设定新密码",
  "确认新密码": "确认新密码",
  "确认": "确认",
  "下一步": "下一步",
  "交易功能": "交易功能",
  "支付方式": "支付方式",
  "充值教学": "充值教学",
  "选择渠道": "选择渠道",
  "存款金额": "存款金额",
  "实际金额": "实际金额",
  "提现币种": "提现币种",
  "提现银行卡": "提现银行卡",
  "新增": "新增",
  "提现金额": "提现金额",
  "提现金额范围": "提现金额范围",
  "请输入金额": "请输入金额",
  "实际到帐": "实际到帐",
  "一般手续费": "一般手续费",
  "强制手续费": "强制手续费",
  "上一步": "上一步",
  "修改成功": "修改成功",
  "修改中": "修改中",
  "拼命加载中": "拼命加载中",
  "编辑登录密码": "编辑登录密码",
  "编辑提款密码": "编辑提款密码",
  "如果您通过手机号码或社交平台登录网站，请联系向客户服务部门寻求帮助。": "如果您通过手机号码或社交平台登录网站，请联系向客户服务部门寻求帮助。",
  "请输入新密码": "请输入新密码",
  "新密码不能和旧密码一致": "新密码不能和旧密码一致",
  "两次输入密码不一致!": "两次输入密码不一致!",
  "请输入提款密码": "请输入提款密码",
  "输入提款密码": "输入提款密码",
  "请设置新的提款密码": "请设置新的提款密码",
  "设置6位提款密码，并记住您的密码": "设置6位提款密码，并记住您的密码",
  "请输入新的提款密码": "请输入新的提款密码",
  "存款": "存款",
  "取款": "取款",
  "付款方式": "付款方式",
  "存款金额": "存款金额",
  "请输入金额": "请输入金额",
  "下一步": "下一步",
  "提款金额": "提款金额",
  "提款银行卡": "提款银行卡",
  "请输入您的银行卡号": "请输入您的银行卡号",
  "切换语言将会刷新页面": "切换语言将会刷新页面",
  "充值方式": "充值方式",
  "取消": "取消",
  "登录过期,是否重新登录": "登录过期,是否重新登录",
  "系统提示": "系统提示",
  "国家": "国家",
  "请输入": "请输入",
  "请选择": "请输入",

  //新的一套
  "加载更多": "加载更多",
  "开始": "开始",
  // "存取款":"Deposit/Withdrawal",
  "存取款": "存取款",
  "加钱": "加钱",
  "选择您的奖金": "选择您的奖金",
  "100%,最高1500": "100%,最高1500",
  "CASINO": "CASINO",
  "Select your lottery": "Select your lottery",
  "don't want a lottery": "don't want a lottery",
  "金额不得小于": "金额不得小于",
  "金额不得大于": "金额不得大于",
  "加载失败": "加载失败",
  "活动中心": "活动中心",
  "**财富攀升-BRL的充值促销**": "**财富攀升-BRL的充值促销**",
  "在这个独特的活动中，我们为您提供了一个积累财富的无尽机会。无论你是初学者还是老手，每次充值都会为你带来不同级别的礼物以及更高级别的特权。": "在这个独特的活动中，我们为您提供了一个积累财富的无尽机会。无论你是初学者还是老手，每次充值都会为你带来不同级别的礼物以及更高级别的特权。",
  "**青铜级别（青铜）**": "**青铜级别（青铜）**",
  "-重新加载的总金额：1.000-5.000 BRL": "-重新加载的总金额：1.000-5.000 BRL",
  "-礼品的比例从5%逐渐增加到10%": "-礼品的比例从5%逐渐增加到10%",
  "-第一次充值时，您将收到一份专属礼物。通往财富的大门是敞开的。每充值一次，就会收到更多的礼物。": "-第一次充值时，您将收到一份专属礼物。通往财富的大门是敞开的。每充值一次，就会收到更多的礼物。",
  "**银级（银级）**": "**银级（银级）**",
  "-重新加载的总金额：5.001-15.000 BRL": "-重新加载的总金额：5.001-15.000 BRL",
  "-礼品的比例从10%逐渐增加到15%": "-礼品的比例从10%逐渐增加到15%",
  "-您已达到白银级别，您的财富将继续增长。充值越多，礼品比例就越高。重新加载更多，赚取更多！": "-您已达到白银级别，您的财富将继续增长。充值越多，礼品比例就越高。重新加载更多，赚取更多！",
  "**黄金级别（Gold）**": "**黄金级别（Gold）**",
  "-重新加载的总金额：15.001-30.000 BRL": "-重新加载的总金额：15.001-30.000 BRL",
  "-礼品的比例从15%逐渐增加到18%": "-礼品的比例从15%逐渐增加到18%",
  "-你正走在富有的贵族之路上。成为金牌会员后，您将收到更多慷慨的礼物。你的财富注定会兴旺发达。": "-你正走在富有的贵族之路上。成为金牌会员后，您将收到更多慷慨的礼物。你的财富注定会兴旺发达。",
  "**白金级别（白金）**": "**白金级别（白金）**",
  "-随着冷却值的增加，会奖励更多的礼物": "-随着冷却值的增加，会奖励更多的礼物",
  "-重新加载的总金额：30.001-60.000 BRL": "-重新加载的总金额：30.001-60.000 BRL",
  "-礼品的比例从18%逐渐增加到20%": "-礼品的比例从18%逐渐增加到20%",
  "-在白金级别，您的充值将获得更高比例的礼物。你的理财能力会变得更加卓越，并获得丰厚的回报。": "-在白金级别，您的充值将获得更高比例的礼物。你的理财能力会变得更加卓越，并获得丰厚的回报。",
  "**钻石级别（钻石）**": "**钻石级别（钻石）**",
  "-重新加载的总金额：60.001-100.000 BRL": "-重新加载的总金额：60.001-100.000 BRL",
  "-礼品比例最高，达到20%": "-礼品比例最高，达到20%",
  "-这是荣誉的高度，是最终的选择。成为钻石会员后，您将享受最高比例的礼物，使您的财富加速增长，您的财务梦想即将实现。": "-这是荣誉的高度，是最终的选择。成为钻石会员后，您将享受最高比例的礼物，使您的财富加速增长，您的财务梦想即将实现。",
  "不要错过这个难得的机会。攀登财富的阶梯，看着你的财富成倍增长。加入我们的“财富攀登”BRL补充促销活动，确保为实现您的财务目标提供最佳支持。财富之旅从你开始，回报不会停止增长，成功就在你身边！": `不要错过这个难得的机会。攀登财富的阶梯，看着你的财富成倍增长。加入我们的“财富攀登”BRL补充促销活动，确保为实现您的财务目标提供最佳支持。财富之旅从你开始，回报不会停止增长，成功就在你身边！`,
  "游戏记录": "游戏记录",
  "交易记录": "交易记录",
  "提交": "提交",
  "游戏品牌": "游戏品牌",
  "游戏名称": "游戏名称",
  "下注时间": "下注时间",
  "下注金额": "下注金额",
  "输赢金额": "输赢金额",
  "上一页": "上一页",
  "下一页": "下一页",
  "申请时间": "申请时间",
  "状态": "状态",
  "法规与合作伙伴": "法规与合作伙伴",
  "为了注册本网站，用户必须接受一般条款和条件。如果条款和条件发生更新，现有用户可以选择在上述更新生效之前停止使用产品和服务，即在更新公布后至少两周。tambet911.com 由JajajEmmi B.V.运营，注册号为150790，地址为Abraham Mendez Chumaceiro Boulevard 03，Willemstad，Curacao。本网站由库拉索岛电子博彩公司许可和监管，许可证号为1668/JAZ。": "In order to register for this website, users must accept the general terms and conditions. If the terms and conditions are updated, existing users can choose to stop using the products and services before the aforementioned update takes effect, that is, at least two weeks after the update is announced. Tambet911.com is operated by JajajEmmi B.V. with registration number 150790 and its address is Abraham Mendez Chumaceiro Boulevard 03, Willemstad, Curacao. This website is licensed and regulated by Curacao Island Electronic Gaming Company with license number 1668/JAZ.",
  '您可以使用用户名和密码登录': '您可以使用用户名和密码登录',
  '创建账户': '创建账户',
  '银行信息': '银行信息',
  '名称': '名称',
  '时间': '时间',
  '最小': '最小',
  '最大': '最大',
  '即时到账': '即时到账',
  '选择银行': '选择银行',
  '银行账号': '银行账号',
  '请输入银行账号': '请输入银行账号',
  '金额': '金额',
  '支出': '支出',
  '输入金额': '输入金额',
  "暂无数据": "暂无数据",
  '获奖人': '获奖人',
  '游戏榜': '游戏榜',
  '新游戏榜': '新游戏榜',
  '热门游戏榜': '热门游戏榜',
  '电子游戏': '电子游戏',
  '主要余额': '主要余额',
  '历史记录': '历史记录',
  '付款名称': '付款名称',
  '费用': '费用',
  '免费': '免费',
  '立即生效': '立即生效',
  '银行选择': '银行选择',
  '银行账户': '银行账户',
  '充值金额': '充值金额',
  '收款名称': '收款名称',
  '账号类型': '账号类型',
  '收账账号': '收账账号',
  'CPF号码': 'CPF号码',
  '提现密码': '提现密码',
  '请输入名称': '请输入名称',
  '请选择类型': '请选择类型',
  '请输入CPF': '请输入CPF',
  '请输入提现金额': '请输入提现金额',
  '请输入正确的参数': '请输入正确的参数',
  "收藏夹":"收藏夹",
	"敬请期待":"敬请期待",
	"用户":"用户",
	"玩家":"玩家",
	"时间":"时间",
  "赌场":"赌场",
  "体育运动":"体育运动",
  "促销":"促销",
  "支持/法律":"支持/法律",
  "加入我们的社区":"加入我们的社区",
  "赌场主页":"赌场主页",
  "插槽":"插槽",
  "现场赌场":"现场赌场",
  "新版本":"新版本",
  "桌面游戏":"桌面游戏",
  "体育之家":"体育之家",
  "会员俱乐部":"会员俱乐部",
  "优惠促销":"优惠促销",
  "赌博意识":"赌博意识",
  "常问问题":"常问问题",
  "条款和条件":"条款和条件",
  "隐私政策":"隐私政策",
  "赞助和游戏责任":"赞助和游戏责任",
  "页脚文本":"页脚文本",
  "充电时间":"充电时间",
  "订单号":"订单号",
  "充值金额":"充值金额",
  "充值方式":"充值方式",
  "地位":"地位",
  
  '负责任的博彩': '负责任的博彩',
  '快速链接': '快速链接',
  '桌上游戏': '桌上游戏',
  '二十一点': '二十一点',
  '扑克': '扑克',
  '百家乐': '百家乐',
  '掷骰子': '掷骰子',
  '奖金': '奖金',
  '赌场奖金': '赌场奖金',
  '自由旋转': '自由旋转',
	'免费投注': '免费投注',
	'信息': '信息',
  "":"",
  
	"老虎机游戏":"老虎机游戏",
	"赌场游戏":"赌场游戏",
	"更多游戏":"更多游戏",
  "搜索游戏" : "搜索游戏",
  "特色提供商":"特色提供商",
  "Logout":"Log out",
  "Personal Center" : "Personal Center",

  'Arcade': '街机游戏',
  'Bingo': '宾果',
  'Card': '卡片',
  'Casino': '赌场',
  'Crash': '崩溃',
  'Fish': '渔',
  'Live': '实时直播',
  'Lottery': '彩票',
  'Slot': '游戏老虎机',
  'Sports': '体育',
  'Video Game': '视频游戏',
}
export default ch



// WEBPACK FOOTER //
// ./src/utils/lang/config/ch.js